'use client';

import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import clsx from 'clsx';
import { Sticky, StickyContainer } from 'react-sticky';

import type { Product } from '@hyex/dxp/types/store/Product/Product';
import SocialShareButtons from '@hyex/modules/shared/SocialShare';

import ArticleProduct from '../../Product/views/article-product';

type PropTypes = {
  backImg: any;
  articlePath?: string;
  articleProduct: Product | null;
};

const ArticleOptions: FC<PropTypes> = ({ backImg, articleProduct, articlePath }) => {
  const urlRef = useRef<string>('');

  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    urlRef.current = window.location.href;
  }, []);

  useEffect(() => {
    document.addEventListener('scroll', () => {
      const refElement = document.getElementById('sticky-panel');

      try {
        if ((refElement?.offsetTop ?? -1) < 0) {
          setVisible(false);
        }

        if ((refElement?.offsetTop ?? 1) > 0) {
          setVisible(true);
        }
      } catch (e) {
        console.error(e);
      }
    });
  }, []);

  let backPath = '/';

  if (articlePath && articlePath.includes('learn')) {
    backPath = '/learn';
  }

  return (
    <StickyContainer className="sticky-container">
      <Sticky topOffset={-60} className="sticky-options">
        {({ style, isSticky, ...rest }) => (
          <div
            style={{
              ...style,
              marginTop: isSticky ? '85px' : '0px',
              borderBottom: isSticky ? '1px solid #e6e6e6' : 'none',
              padding: isSticky ? '1rem 0' : '3rem 0',
            }}
            className="article-options"
          >
            <div
              className="container"
              style={{
                borderBottom: isSticky ? '' : '1px solid #e6e6e6',
                paddingBottom: isSticky ? '0' : '10px',
              }}
            >
              <Link className="link back-link" href={backPath} prefetch={false}>
                <Image alt="" src={backImg} width={27} height={11} quality="70" />
                <span className="desktop">Back to Articles</span>
                <span className="mobile">Articles</span>
              </Link>

              <div className="share-links">
                <span className="desktop">Share this article</span>
                <span className="mobile">Share</span>
                <SocialShareButtons url={urlRef.current} />
              </div>
            </div>
          </div>
        )}
      </Sticky>
      <Sticky topOffset={-150}>
        {({ style, isSticky, ...rest }) => (
          <div
            className={clsx('article-panel-wrapper', { relative23: !isVisible })}
            style={{
              ...style,
              marginTop: isSticky ? '150px' : '0px',
              paddingBottom: isSticky ? '1000px' : '0px',
              zIndex: isVisible ? 40 : -40,
            }}
            id="sticky-panel"
          >
            {articleProduct && (
              <>
                <ArticleProduct
                  item={articleProduct}
                  className="product-block vertical product-wrapper "
                  storePath="store"
                />
              </>
            )}
          </div>
        )}
      </Sticky>
    </StickyContainer>
  );
};

export default ArticleOptions;
